import HisDashboard from "./library/his-dashboard";
import HisSearch from "./library/his-search";
import HisPersonAdd from "./library/his-person-add";
import HisListSort from "./library/his-list-sort";
import HisMapMarker from "./library/his-map-marker";
import HisCalendar from "./library/his-calendar";
import HisChart from "./library/his-chart";
import HisLastClient from "./library/his-last-client";
import Particles1 from "./library/particles1";
import HisAvatar from "./library/his-avatar";
import Particles2 from "./library/particles2";
import Particles3 from "./library/particles3";
import HisLogo from "./library/his-logo";
import HisNotification from "./library/his-notification";
import HisPerson from "./library/his-person";
import HisPersonCheck from "./library/his-person-check";
import HisRecentDocuments from "./library/his-recent-documents";
import HisHandshakeHeart from "./library/his-handshake-heart";
import HisLayers from "./library/his-layers";
import HisFilters from "./library/his-filters";
import HisMagnifyingGlass from "./library/his-magnifying-glass";
import HisPlus from "./library/his-plus";
import HisPeople from "./library/his-people";
import HisStethoscope from "./library/his-stethoscope";
import HisInjection from "./library/his-injection";
import HisCalendarPlus from "./library/his-calendar-plus";
import HisCalendarSearch from "./library/his-calendar-search";

export class SvgEnum {
  static HisAvatar = "his-avatar";
  static HisCalendar = "his-calendar";
  static HisCalendarPlus = "his-calendar-plus";
  static HisCalendarSearch = "his-calendar-search";
  static HisChart = "his-chart";
  static HisDashboard = "his-dashboard";
  static HisFilters = "his-filters";
  static HisHandshakeHeart = "his-handshake-heart";
  static HisLastClient = "his-last-client";
  static HisLayers = "his-layers";
  static HisListSort = "his-list-sort";
  static HisLogo = "his-logo";
  static HisMagnifyingGlass = "his-magnifying-glass";
  static HisMapMarker = "his-map-marker";
  static HisNotification = "his-notification";
  static HisPeople = "his-people";
  static HisPerson = "his-person";
  static HisPersonAdd = "his-person-add";
  static HisPersonCheck = "his-person-check";
  static HisPlus = "his-plus";
  static HisRecentDocuments = "his-recent-documents";
  static HisSearch = "his-search";
  static Particles1 = "particles1";
  static Particles2 = "particles2";
  static Particles3 = "particles3";
  static Stethoscope = "his-stethoscope";
  static Injection = "his-injection";
}

const Svg = ({ name, onClick, color, sx }) => {
  const styles = sx;

  let Component;
  switch (name) {
    case SvgEnum.HisAvatar:
      Component = HisAvatar;
      break;

    case SvgEnum.HisCalendar:
      Component = HisCalendar;
      break;

    case SvgEnum.HisCalendarPlus:
      Component = HisCalendarPlus;
      break;

    case SvgEnum.HisCalendarSearch:
      Component = HisCalendarSearch;
      break;

    case SvgEnum.HisChart:
      Component = HisChart;
      break;

    case SvgEnum.HisDashboard:
      Component = HisDashboard;
      break;

    case SvgEnum.HisFilters:
      Component = HisFilters;
      break;

    case SvgEnum.HisHandshakeHeart:
      Component = HisHandshakeHeart;
      break;

    case SvgEnum.HisLastClient:
      Component = HisLastClient;
      break;

    case SvgEnum.HisLayers:
      Component = HisLayers;
      break;

    case SvgEnum.HisListSort:
      Component = HisListSort;
      break;

    case SvgEnum.HisLogo:
      Component = HisLogo;
      break;

    case SvgEnum.HisMagnifyingGlass:
      Component = HisMagnifyingGlass;
      break;

    case SvgEnum.HisMapMarker:
      Component = HisMapMarker;
      break;

    case SvgEnum.HisNotification:
      Component = HisNotification;
      break;

    case SvgEnum.HisPeople:
      Component = HisPeople;
      break;

    case SvgEnum.HisPerson:
      Component = HisPerson;
      break;

    case SvgEnum.HisPersonAdd:
      Component = HisPersonAdd;
      break;

    case SvgEnum.HisPersonCheck:
      Component = HisPersonCheck;
      break;

    case SvgEnum.HisPlus:
      Component = HisPlus;
      break;

    case SvgEnum.HisRecentDocuments:
      Component = HisRecentDocuments;
      break;

    case SvgEnum.HisSearch:
      Component = HisSearch;
      break;

    case SvgEnum.Particles1:
      Component = Particles1;
      break;

    case SvgEnum.Particles2:
      Component = Particles2;
      break;

    case SvgEnum.Particles3:
      Component = Particles3;
      break;

    case SvgEnum.Stethoscope:
      Component = HisStethoscope;
      break;

    case SvgEnum.Injection:
      Component = HisInjection;
      break;

    default:
      throw new Error(`"${name}" is not a recognized option in Svg`);
  }

  const { width, ...wrapperStyles } = styles ?? {};

  const svgSx = { width };
  const _wrapperStyles = {
    display: "inline-block",
    ...wrapperStyles,
  };

  return (
    <span onClick={onClick ?? (() => {})} style={_wrapperStyles}>
      <Component color={color} sx={svgSx} />
    </span>
  );
};

export default Svg;
